import { css } from '@emotion/react'
import styled from '@emotion/styled'

const baseStyles = () => css`
  img {
    label: sketchfab-model__preview-image;

    cursor: pointer;
  }
`

export const SketchfabModel = styled('div')(baseStyles)
